module.exports = __webpack_public_path__ + "img/angular.18693f39.svg";